import { CircularProgress, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AppRoutes, ButtonsColorType, ButtonsType } from "../../types/enums";
import { GradientButton, ReuseButton } from "../ui";
import { ReactNode } from "react";
import { useAppSelector } from "../../hooks";

type Props = {
  campaign_id: string;
  totalAccounts: number;
  title: string;
  description: string;
  buttonText: string;
  icon?: ReactNode;
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  btnBlock?: ReactNode;
};

export const NoInfoDataBlock = ({
  campaign_id,
  totalAccounts,
  title,
  description,
  buttonText,
  icon,
  onClick,
  isLoading,
  isDisabled,
  btnBlock,
}: Props) => {
  const navigate = useNavigate();

  const { isEditor } = useAppSelector((state) => state.company.userRoles);

  return (
    <Stack
      sx={{
        width: "100%",
        gap: "24px",
        borderRadius: "6px",
        boxShadow: "0 4px 15.8px 0 #0000001A",
        padding: "24px 16px",
        overflow: "visible",
      }}
    >
      <Typography
        variant="h4"
        color="custom.textDarkBlue"
        sx={{
          borderBottom: "1px solid #D9D9D9",
          paddingBottom: "16px",
        }}
      >
        Statistics
      </Typography>

      <Stack>
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap="16px"
        >
          <Typography variant="h4" color="custom.textDarkBlue">
            {totalAccounts}
          </Typography>
        </Stack>
        <Typography variant="button" color="#3F4041B2" sx={{ fontWeight: 400 }}>
          added accounts
        </Typography>
      </Stack>

      <ReuseButton
        fullWidth
        buttonColor={ButtonsColorType.blue_white}
        buttonType={ButtonsType.contained}
        onClick={() => navigate(`${AppRoutes.ACCOUNTS_LIST}/${campaign_id}`)}
      >
        View Accounts
      </ReuseButton>

      {isEditor && (
        <Stack
          sx={{
            backgroundColor: "#ECEEF099",
            borderRadius: "6px",
            padding: "24px 16px 16px",
            gap: "32px",
          }}
        >
          <Stack gap={"6px"}>
            {icon}

            <Typography variant="subtitle1" fontWeight={500}>
              {title}
            </Typography>
            <Typography variant="body1" color="#4C545B">
              {description}
            </Typography>
          </Stack>
          {btnBlock ? (
            btnBlock
          ) : (
            <GradientButton fullWidth onClick={onClick} disabled={isDisabled}>
              {isLoading && (
                <CircularProgress size={20} sx={{ color: "inherit" }} />
              )}
              {buttonText}
            </GradientButton>
          )}
        </Stack>
      )}
    </Stack>
  );
};
